
    import './styles.scoped.css';
    export default {
  "visible-content": "awsui_visible-content_tc96w_9rkzq_281",
  "visible-content-toggle": "awsui_visible-content-toggle_tc96w_9rkzq_282",
  "visible-content-groups": "awsui_visible-content-groups_tc96w_9rkzq_283",
  "visible-content-group": "awsui_visible-content-group_tc96w_9rkzq_283",
  "visible-content-title": "awsui_visible-content-title_tc96w_9rkzq_288",
  "visible-content-group-label": "awsui_visible-content-group-label_tc96w_9rkzq_298",
  "visible-content-option": "awsui_visible-content-option_tc96w_9rkzq_304",
  "visible-content-option-label": "awsui_visible-content-option-label_tc96w_9rkzq_317",
  "content-display-option-toggle": "awsui_content-display-option-toggle_tc96w_9rkzq_604",
  "content-display-option-content": "awsui_content-display-option-content_tc96w_9rkzq_608",
  "content-display-option": "awsui_content-display-option_tc96w_9rkzq_604",
  "placeholder": "awsui_placeholder_tc96w_9rkzq_658",
  "sorting": "awsui_sorting_tc96w_9rkzq_658",
  "content-display-option-label": "awsui_content-display-option-label_tc96w_9rkzq_685",
  "drag-overlay": "awsui_drag-overlay_tc96w_9rkzq_692",
  "content-display": "awsui_content-display_tc96w_9rkzq_604",
  "content-display-text-filter": "awsui_content-display-text-filter_tc96w_9rkzq_722",
  "content-display-no-match": "awsui_content-display-no-match_tc96w_9rkzq_723",
  "content-display-title": "awsui_content-display-title_tc96w_9rkzq_727",
  "content-display-description": "awsui_content-display-description_tc96w_9rkzq_736",
  "content-display-option-list": "awsui_content-display-option-list_tc96w_9rkzq_744",
  "root": "awsui_root_tc96w_9rkzq_751",
  "modal-root": "awsui_modal-root_tc96w_9rkzq_752",
  "trigger-button": "awsui_trigger-button_tc96w_9rkzq_753",
  "cancel-button": "awsui_cancel-button_tc96w_9rkzq_754",
  "confirm-button": "awsui_confirm-button_tc96w_9rkzq_755",
  "custom": "awsui_custom_tc96w_9rkzq_756",
  "second-column-small": "awsui_second-column-small_tc96w_9rkzq_760",
  "wrap-lines": "awsui_wrap-lines_tc96w_9rkzq_764",
  "striped-rows": "awsui_striped-rows_tc96w_9rkzq_765",
  "content-density": "awsui_content-density_tc96w_9rkzq_766",
  "page-size": "awsui_page-size_tc96w_9rkzq_767",
  "page-size-form-field": "awsui_page-size-form-field_tc96w_9rkzq_768",
  "page-size-radio-group": "awsui_page-size-radio-group_tc96w_9rkzq_769",
  "sticky-columns": "awsui_sticky-columns_tc96w_9rkzq_770",
  "sticky-columns-form-field": "awsui_sticky-columns-form-field_tc96w_9rkzq_771",
  "sticky-columns-radio-group": "awsui_sticky-columns-radio-group_tc96w_9rkzq_772",
  "sticky-columns-first": "awsui_sticky-columns-first_tc96w_9rkzq_773",
  "sticky-columns-last": "awsui_sticky-columns-last_tc96w_9rkzq_774"
};
  